import { render } from "./SubjectDetailPage.vue?vue&type=template&id=43d79c82"
import script from "./SubjectDetailPage.vue?vue&type=script&lang=js"
export * from "./SubjectDetailPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__